import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";

const options = [
  { value: "qrCode", label: "QR code" },
  { value: "barcode39", label: "Barcode 39" },
  { value: "barcode128", label: "Barcode 128" },
];

const QRCodeDialog = ({ open, handleClose, handleAdd }) => {
  const [type, setType] = useState("qrCode");
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    setType("qrCode");
    setValue("");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      TransitionProps={{
        onEntered: handleEntered,
      }}
    >
      <DialogContent>
        <h3 className="dialog-title">Add QR code or barcode</h3>
        <div className="dialog-description">
          Select the type of code and type the value for it
        </div>
        <Select
          options={options}
          value={options.find((option) => option.value === type)}
          onChange={({ value }) => setType(value)}
          placeholder="Select type of code"
          className="code-type-select"
        />
        <TextField
          margin="dense"
          label="Code value"
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          inputRef={inputRef}
        />
      </DialogContent>
      <DialogActions>
        <button className="button" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="primary"
          disabled={!value}
          onClick={() =>
            handleAdd({
              type,
              value,
            })
          }
        >
          Add code
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeDialog;
